(function () {
  const MINIMUM_ORDER_CENTS = parseInt(
    document.documentElement.getAttribute('data-minimum-order-cents') || '2500',
    10
  );

  function getErrorContainer(form) {
    if (form.id === 'CartDrawer-Form') {
      return document.getElementById('CartDrawer-CartErrors');
    }
    if (form.id === 'cart-notification-form') {
      let errorEl = form.querySelector('.minimum-order-error');
      if (!errorEl) {
        errorEl = document.createElement('p');
        errorEl.className = 'minimum-order-error caption-large';
        errorEl.setAttribute('role', 'alert');
        form.insertAdjacentElement('beforebegin', errorEl);
      }
      return errorEl;
    }
    return document.getElementById('cart-errors');
  }

  async function handleCheckoutSubmit(event) {
    const submitter = event.submitter;
    if (!submitter || submitter.name !== 'checkout') return;

    const form = event.target;
    if (!form.matches('#cart, #CartDrawer-Form, #cart-notification-form')) return;

    if (form.dataset.minimumOrderValidated === 'true') {
      form.dataset.minimumOrderValidated = '';
      return;
    }

    event.preventDefault();

    try {
      const cartUrl = window.routes?.cart_url || '/cart';
      const cart = await fetch(`${cartUrl}.js`).then((response) => response.json());

      if (cart.total_price >= MINIMUM_ORDER_CENTS) {
        form.dataset.minimumOrderValidated = 'true';
        form.requestSubmit(submitter);
        return;
      }

      const errorContainer = getErrorContainer(form);
      if (errorContainer) {
        errorContainer.textContent = window.cartStrings.minimumOrderError;
      }

      form.querySelectorAll('[name="checkout"]').forEach((button) => {
        button.disabled = true;
      });
    } catch (error) {
      console.error(error);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('#cart, #CartDrawer-Form, #cart-notification-form').forEach((form) => {
      form.addEventListener('submit', handleCheckoutSubmit);
    });
  });
})();
